<div  id="test2" class="fixed-screen-map">

    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

    </div>

    <div class="position-absolute" id="map_tooltips" data-bs-html="true">

    </div>

    <div class="row fixed-area-screen p-1">

        <div class="col-4 text-start">

            <i class="fa fa-trash text-danger bg-pink fa-2x " title="حذف محدوده" (click)="deleteArea()"></i>

            <i *ngIf="editMode" class="fa fa-pencil text-primary bg-blue-light mx-2 fa-2x " title="ویرایش" (click)="editArea()"></i>

        </div>

        <div class="col-4 ">

            <select class="form-select " (change)="GeoFence($event.target.value) " id="areaSelection " [value]="GeoFenceId">

                <option value="-1 " class="text-center vazir ">انتخاب کنید</option>

                <option class="text-center vazir " *ngFor="let item of list_Geofence " value="{{item.iGeoFence}} ">

                    {{item.strTitle}}

                </option>

            </select>


        </div>

        <div class="col-4 text-end ">

            <i class="fa fa-plus-circle fa-2x" title="اضافه کردن محدوده" (click)="addInteraction()"></i>

        </div>
        
    </div>

    <div class="icon-Map position-absolute index d-flex flex-column ">

        <img src="../../../assets/Img/layer-icon.png" title="تغییر نوع نقشه" (click)="changeTail()" class="bg-third p-2 circel-2 my-1 text-center pointer text-white icon-Img">

    </div>

</div>

<div class="modal fade rtl " id="savePolygan" tabindex="-1" aria-hidden="true">

    <div class="modal-dialog ">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="">{{editMode ? 'ویرایش' : 'ثبت' }} محدوده</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body ">

                <div class="col-11 mx-auto">

                    <label class="">نام محدوده</label>

                    <input [formControl]="polyganName" class="form-control">

                </div>

            </div>

            <div class="modal-footer">

                <button *ngIf="!editMode" type="button" class="btn btn-success" (click)="savePolygon()">ثبت <i class="fa fa-angle-double-down"></i> </button>

                <button *ngIf="editMode" type="button" class="btn btn-primary" (click)="submitEditedTitle()"> ویرایش <i class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-danger " data-bs-dismiss="modal">بستن <i class="fa fa-close"></i></button>

            </div>

        </div>

    </div>

</div>